export class ApplicationConfig {

    public real_data: boolean;
    public sap_integration: boolean;
    public non_adherance: boolean;
    public non_compliance: boolean;
    public detailed_report: boolean;
    public summarized_report: boolean;
    public employee: any;
    public userDetails: any;
    public timeSheetEntry: any;

    constructor(data: any = {}) {
        if (data.sap_integration === undefined) {
            this.real_data = false;
        } else {
            this.real_data = true;
        }
        this.sap_integration =  data.sap_integration || false;
        this.non_adherance = data.non_adherance || false;
        this.non_compliance = data.non_compliance || false;
        this.detailed_report = data.detailed_report || false;
        this.summarized_report = data.summarized_report || false;
        this.employee = new EmployeeDetails(data.employee);
        this.timeSheetEntry = new TimeSheetEntry(data.timeSheetEntry);
    }
}

export class EmployeeDetails {
    public addEmployee: boolean;
    public updateEmployee: boolean;
    public editEmployee: any;
    public employee_list: string;

    constructor(data: any = {}) {
       this.addEmployee = data.addEmployee || false;
       this.updateEmployee = data.updateEmployee || false;
       this.employee_list = data.employee_list || 'ipdo';
       this.editEmployee = new EditEmployee(data.editEmployee);
    }
}

export class EditEmployee {
    public name: boolean;
    public no: boolean;
    public emailId: boolean;
    public reportingManagerCheck: boolean;
    public reportingManagerId: boolean;
    public reportingManager: boolean;
    public team: boolean;
    constructor(data: any = {}) {
        this.name = data.name || false;
        this.emailId = data.emailId || false;
        this.no = data.no || false;
        this.reportingManagerCheck = data.reportingManagerCheck || false;
        this.reportingManagerId = data.reportingManagerId || false;
        this.reportingManager = data.reportingManager || false;
        this.team = data.team || false;
    }
}

export class TimeSheetEntry {
    public employeeType: string;
    public exceedTimeLimit: any;
    public lessTimeLimit: any;
    public saveTimeSheet: boolean;
    public submitDay: string;
    constructor(data: any = {}) {
        this.employeeType = data.employeeType || '';
        this.exceedTimeLimit = data.exceedTimeLimit || '';
        this.lessTimeLimit = data.lessTimeLimit || '';
        this.saveTimeSheet = data.saveTimeSheet || false;
        this.submitDay = data.submitDay || '';
    }
}



// WEBPACK FOOTER //
// ./src/app/utils/models/config.ts